import React from 'react'
import styles from './StatusPill.module.scss'

export const StatusPill: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <span className={styles.pill}>
    <span className={styles.dot} aria-hidden="true" />
    {children}
  </span>
)
